export default "assets/images/logo-817d13f4.png";